import React from 'react';
import { CellTemplateProps, ColumnProps } from 'fulogics-ui-web';
import enOrderStepType from '../../../../../api/enums/enOrderStepType';
import { formatDate } from 'fulogics-ui-core/dist/utils/dates';

const OrderReturnPlannedStartDateColumnTemplate = (props: CellTemplateProps) => {
    const isLoad = props?.data?.type === enOrderStepType.Load;
    const plannedStartDate = props?.data?.plannedStartDate;

    return (
        <>
            {isLoad ? (
                <div>
                    {plannedStartDate ? formatDate(plannedStartDate, 'DD.MM.yyyy, HH:mm') : ''}
                </div>
            ) : (
                <div />
            )}
        </>
    );
};

export const OrderReturnPlannedStartDateColumnTemplateDefaultProps = {};

export const OrderReturnPlannedStartDateColumnTemplatePredProps = (
    current: ColumnProps
): ColumnProps => {
    return {
        ...current,
    };
};

export type OrderReturnPlannedStartDateColumnTemplateData = { plannedStartDate?: Date };

export const OrderReturnPlannedStartDateColumnTemplateDataKeys = ['plannedStartDate'];

export default OrderReturnPlannedStartDateColumnTemplate;
